export enum LicenseKey  {
  licenseKey = 'LicenseKey',
  kmsServer = 'KmsServer'
}
